"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteUpdateReceivableTransport = exports.CustomerBalanceTransport = exports.WaysteCreateAndChargeReceivableTransport = exports.WaysteCreateReceivableTransport = exports.WaysteReceivableTransport = exports.CustomerReceivableTransport = exports.ReceivableUpdateTransport = exports.CreateAndChargeReceivableTransport = exports.ReceivableCreateTransport = exports.PaymentWithReceivableTransport = exports.ReceivableTransport = exports.InvoiceIssueNotificationType = exports.InvoiceIssueNotificationTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const autopay_request_1 = require("./autopay-request");
const invoice_transport_1 = require("./invoice-transport");
const payment_processing_1 = require("./payment-processing");
const payment_transport_1 = require("./payment-transport");
exports.InvoiceIssueNotificationTypes = ['invoice-commercial'];
exports.InvoiceIssueNotificationType = typebox_1.Type.Union(exports.InvoiceIssueNotificationTypes.map((type) => typebox_1.Type.Literal(type)));
exports.ReceivableTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    customerID: typebox_1.Type.String(),
    // Optional during Unified Billing rollout: Wayste receivables carry a real haulerID;
    // Sourgum receivables leave it unset (derived as the SOURGUM_HAULER_ID sentinel downstream).
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    stripeInvoiceID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceDetails: invoice_transport_1.InvoiceTransport,
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerCompanyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerAccountNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopayRequests: typebox_1.Type.Optional(typebox_1.Type.Array(autopay_request_1.AutopayRequest)),
    issueNotificationSentOn: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'date-time',
        description: 'Date issue notification email was sent for this invoice, if any',
    })),
    issueNotificationType: typebox_1.Type.Optional(exports.InvoiceIssueNotificationType),
});
exports.PaymentWithReceivableTransport = typebox_1.Type.Intersect([
    payment_transport_1.PaymentTransport,
    typebox_1.Type.Object({
        receivable: exports.ReceivableTransport,
    }),
]);
exports.ReceivableCreateTransport = typebox_1.Type.Object({
    customerID: typebox_1.Type.String(),
    stripeInvoiceID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceDetails: invoice_transport_1.InvoiceCreateTransport,
    issueNotificationSentOn: typebox_1.Type.Optional(typebox_1.Type.String({
        format: 'date-time',
        description: 'Date issue notification email was sent for this invoice, if any',
    })),
    issueNotificationType: typebox_1.Type.Optional(exports.InvoiceIssueNotificationType),
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerCompanyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerAccountNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopayRequest: typebox_1.Type.Optional(autopay_request_1.AutopayRequestCreate),
    // Unified Billing superset: Wayste create carries a subscriptionNumber; Sourgum leaves it unset.
    subscriptionNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.CreateAndChargeReceivableTransport = typebox_1.Type.Intersect([
    exports.ReceivableCreateTransport,
    typebox_1.Type.Partial(typebox_1.Type.Object({
        charge: typebox_1.Type.Object({
            chargeDescription: typebox_1.Type.Optional(typebox_1.Type.String()),
            paymentMethodID: typebox_1.Type.String(),
            paymentProcessor: payment_processing_1.SupportedPaymentProcessorTransport,
            stripeCustomer: typebox_1.Type.Optional(typebox_1.Type.String()),
        }),
    })),
]);
exports.ReceivableUpdateTransport = typebox_1.Type.Object({
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeInvoiceID: typebox_1.Type.Optional(typebox_1.Type.String()),
    invoiceDetails: typebox_1.Type.Optional(invoice_transport_1.InvoiceUpdateTransport),
    issueNotificationSentOn: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({
        format: 'date-time',
        description: 'Date issue notification email was sent for this invoice, if any',
    }))),
    issueNotificationType: typebox_1.Type.Optional((0, common_1.Nullable)(exports.InvoiceIssueNotificationType)),
});
exports.CustomerReceivableTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    customerID: typebox_1.Type.String(),
    invoiceDetails: invoice_transport_1.CustomerInvoiceTransport,
    paymentToken: typebox_1.Type.String(),
    // order: Type.Optional(AllianceOrderCustomerTransport),
});
/** @deprecated Use {@link ReceivableTransport} (unified). TODO(ENG-1026): remove this alias. */
exports.WaysteReceivableTransport = exports.ReceivableTransport;
/** @deprecated Use {@link ReceivableCreateTransport} (unified, now carries optional subscriptionNumber). TODO(ENG-1026): remove this alias. */
exports.WaysteCreateReceivableTransport = exports.ReceivableCreateTransport;
/**
 * @deprecated Diverges from {@link CreateAndChargeReceivableTransport} (flat charge fields + idempotencyKey vs nested `charge`).
 * TODO(ENG-1026): migrate consumers to CreateAndChargeReceivableTransport and remove this type.
 */
exports.WaysteCreateAndChargeReceivableTransport = typebox_1.Type.Intersect([
    exports.WaysteCreateReceivableTransport,
    typebox_1.Type.Partial(typebox_1.Type.Object({
        chargeDescription: typebox_1.Type.String(),
        paymentMethodID: typebox_1.Type.String(),
        paymentProcessor: payment_processing_1.SupportedPaymentProcessorTransport,
        stripeCustomer: typebox_1.Type.Optional(typebox_1.Type.String()),
        idempotencyKey: typebox_1.Type.String(),
    })),
]);
exports.CustomerBalanceTransport = typebox_1.Type.Object({
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    balance: typebox_1.Type.Integer(),
    amountDue: typebox_1.Type.Integer(),
});
/** @deprecated Use {@link ReceivableUpdateTransport} (unified). TODO(ENG-1026): remove this alias. */
exports.WaysteUpdateReceivableTransport = exports.ReceivableUpdateTransport;
//# sourceMappingURL=receivable-transport.js.map